// export const CardTokenAddress = '0x65F2d1439b0D37d216F8E11945A3Ee02D51B4b2f';
// export const PackTokenAddress = '0x0F7B97b09eefe4170aeC0Ed81f85Ea2919DEBAf3';
export const CardTokenAddress = '0xa698b4de86e27be81f6deb2efaf98b4a010cfd0f';
export const PackTokenAddress = '0x8045Cb5F58b9a53464121ED22067F28715E55b18';
export const Bubble1Text = "Weary traveler!     I've been expecting you.";
export const Bubble2Text =
	'Yes, yes, I have exactly what a collector like you has been searching for. Do come inside.';
